import React, {useState, useEffect, useRef} from 'react';

import {
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const UnderConstruction = (): JSX.Element => {

    return (<div className={'w-full text-center'}>
        <FontAwesomeIcon className="sidebar-icon mr-2"
                         style={{
                             fontSize: '8rem',
                             // background: 'radial-gradient(circle, rgba(245,255,0,1) 12%, rgba(189,174,3,1) 86%, rgba(145,132,8,1) 100%)',
                         }}
                         icon={faExclamationTriangle}/>
        <div>wird noch gebaut...</div>
    </div>);
};

export default UnderConstruction;
